// Centralized axios instance for the Fabric Manager.
//
// All requests use session cookies (`withCredentials: true`) for auth — the
// legacy committed `apikey` header is intentionally gone. The session cookie is
// set by the central tt-frankford-auth portal and shared across the *.tt domain.
import axios from "axios";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_NODE_URL,
  withCredentials: true,
});

export const CDN_URL =
  process.env.VUE_APP_CDN_URL || "https://frankford.b-cdn.net";

export function swatchUrl(textureKey?: string, cacheBust?: string | number): string {
  if (!textureKey) return "";
  const bust = cacheBust ? `?v=${cacheBust}` : "";
  return `${CDN_URL}/fabric_swatches/${textureKey}.jpg${bust}`;
}

// Swatch URL built from the fabric's stored `image` filename (which already
// includes the extension). Falls back to the texture_key-based path.
export function swatchImageUrl(image?: string, cacheBust?: string | number): string {
  if (!image) return "";
  const bust = cacheBust ? `?v=${cacheBust}` : "";
  return `${CDN_URL}/fabric_swatches/${image}${bust}`;
}

export function textureUrl(textureKey?: string, cacheBust?: string | number): string {
  if (!textureKey) return "";
  const bust = cacheBust ? `?v=${cacheBust}` : "";
  return `${CDN_URL}/sd/textures/${textureKey}.jpg${bust}`;
}

export default api;
